import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

type AccountUser = components['schemas']['GetAccountUsersAutocompleteEndpoint_GetUsersResponse'];

interface UseAccountUsersAutocompleteOptions {
  filter: string;
  limit?: number;
  enabled?: boolean;
}

export function useAccountUsersAutocomplete({ filter, limit = 50, enabled = true }: UseAccountUsersAutocompleteOptions) {
  const { getAccessToken } = useAuth();

  const isFetchEnabled = enabled && filter.length >= 3;

  return useQuery({
    queryKey: ['accountUsersAutocomplete', filter, limit],
    queryFn: async () => {
      const client = createApiClient(getAccessToken);
      const { data, error } = await client.GET('/api/users/account-manager/autocomplete', {
        params: {
          query: {
            Filter: filter,
            Limit: limit,
          },
        },
      });

      if (error) {
        throw new Error('Failed to fetch account users');
      }

      return (data as AccountUser[]) || [];
    },
    enabled: isFetchEnabled,
    staleTime: 30000,
  });
}
